// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'
import Box from '@mui/material/Box'
import CardHeader from '@mui/material/CardHeader'
import Button from '@mui/material/Button'
import CardContent from '@mui/material/CardContent'
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'

import {
    Divider,
    IconButton,
    Tooltip,
    Fab,
    Typography,
    InputLabel,
    Select,
    MenuItem,
} from '@mui/material'
import { useNavigate } from "react-router-dom";
import axios from 'axios'

import Icon from '../../../components/icon';
import apiUrl from '../../../configs/constant';
import MsiDatagrid from '../../../components/custom/MsiDatagridAuto';
import MsiDatagridCheckbox from '../../../components/custom/MsiDatagridAutoCheckbox';

import moment from 'moment'
import Tab from '@mui/material/Tab'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'

import CardStats from '../../../components/card/CardStats';
import { useToast } from '../../../components/ToastProvider';
import Swal from 'sweetalert2'
import { getDoctag } from '../../../api/helper'

export default function Index() {
    const { showToast, hideToast } = useToast();
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token

    // ** State
    const [tabs, setTabs] = useState<string>("1")

    const [tglAwal, setTglAwal] = useState<string>(moment().subtract(3, 'months').startOf('month').format('YYYY-MM-DD'))
    const [tglAkhir, setTglAkhir] = useState<string>(moment().endOf('month').format('YYYY-MM-DD'))

    const [listData, setListData] = useState<any[]>([])
    const [listDoctag, setListDoctag] = useState<any[]>([])

    const [sysdoctag, setSysdoctag] = useState<string>('')
    const [sysdoctagId, setSysdoctagId] = useState<string>('')
    const [filter, setFilter] = useState<string>('1')

    const [selectedList, setSelectedList] = useState<any[]>([])
    const [selectedPR, setSelectedPR] = useState<any>(null)

    const [listCard, setListCard] = useState<any[]>([])

    useEffect(() => {
        getData(tabs)
        getCardFilter(filter, sysdoctag)
        const getDoctag = () => {
            const url = apiUrl.apiUrl + '/system/doctag/list-combo'
            axios
                .get(url, {
                    params: {
                        syscabang_id: 1,
                        sysmenu_id: 37
                    },
                    headers: { Authorization: `Bearer ${token}` }
                })
                .then(response => {
                    if (response.data.success) {
                        const data = response.data.data
                        setListDoctag(data)
                    } else {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: response.data.message,
                            icon: 'error'
                        })
                    }
                })
        }

        getDoctag();
    }, [])

    const navigate = useNavigate();

    const getData = (mode: any) => {
        showToast("Loading...", "loading");
        let url = ''
        if (mode == '1') {
            url = apiUrl.apiUrl + '/purchasing/pr/dashboard/semua-pr'
        } else if (mode == '2') {
            url = apiUrl.apiUrl + '/purchasing/pr/dashboard/pr-belum-aktif'
        } else {
            url = apiUrl.apiUrl + '/purchasing/pr/dashboard/progress-pembelian'
        }

        axios
            .get(url, {
                params: {
                    awal: tglAwal,
                    akhir: tglAkhir,
                    doctag: sysdoctagId
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListData(data)
                    hideToast();
                } else {
                    showToast(response.data.message, "success");
                }
            })
    }

    const getCardFilter = (filter: any, sysdoctag: any) => {
        setFilter(filter)

        const url = apiUrl.apiUrl + '/purchasing/pr/dashboard/card-erp'
        axios
            .get(url, {
                params: { mode: filter, sysdoctag_id: sysdoctag },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListCard(data)
                } else {
                    showToast(response.data.message, "success");
                }
            })
    }

    const handleChangeTabs = (event: SyntheticEvent, newValue: string) => {
        setTabs(newValue)
        getData(newValue)
    }

    const handleSelection = (data: any) => {
        setSelectedList(data.selectedRowsData)
        setSelectedPR(JSON.stringify(data.selectedRowsData))
    };

    const onBatalPR = (pid: any) => {
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin batal PR ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Batal',
            allowOutsideClick: false,
            allowEscapeKey: false,
            focusConfirm: false,
            returnFocus: false
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                const url = apiUrl.apiUrl + '/purchasing/pr/batal-pr/' + pid
                axios
                    .post(url, {}, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    getData(tabs)
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })
            }
        })
    }

    const actionData = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 150,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Tooltip title="Lihat Detail" placement="top">
                        <Box>
                            <IconButton onClick={() => navigate('/purchasing/purchase-request/detail/' + row.id)}>
                                <Icon icon="mdi:search" color="#1976d2" />
                            </IconButton>
                        </Box>
                    </Tooltip>
                    <Tooltip title="Print" placement="top">
                        <Box>
                            <IconButton onClick={() => window.open(apiUrl.baseUrl + '/purchasing/purchase-request/preview/' + row.id, '_blank')}>
                                <Icon icon="mdi:file-pdf" color="#1db124" />
                            </IconButton>
                        </Box>
                    </Tooltip>
                    {
                        row.is_aktif === 0 ? (
                            <Tooltip title="Batalkan PR" placement="top">
                                <Box>
                                    <IconButton onClick={() => onBatalPR(row.id)}>
                                        <Icon icon="mdi:trash" color="#d32f2f" />
                                    </IconButton>
                                </Box>
                            </Tooltip>
                        ) : null
                    }
                </Box>
            ),

        },
    ];

    const onOtorisasiPR = () => {
        Swal.fire({
            title: 'Konfirmasi',
            text: `Apakah anda ingin otorisasi ${selectedList.length} data ?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Otorisasi'
        }).then(async (result) => {
            if (!result.isConfirmed) return

            Swal.fire({
                title: 'Now loading',
                allowEscapeKey: false,
                allowOutsideClick: false,
                didOpen: () => Swal.showLoading()
            })

            try {
                const requests = selectedList.map(el => {

                    const url = `${apiUrl.apiUrl}/purchasing/pr/oto-pr/${el.id}`
                    return axios.post(url, {}, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                })

                const responses = await Promise.all(requests)

                const hasError = responses.some(r => !r.data.success)

                if (!hasError) {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: 'Semua data berhasil diotorisasi',
                        icon: 'success',
                        timer: 1200,
                        timerProgressBar: true,
                        willClose: () => {
                            getData(tabs)
                        }
                    })
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: 'Gagal diotorisasi',
                        icon: 'warning'
                    })
                }
            } catch (error: any) {
                Swal.fire({
                    title: 'Pemberitahuan',
                    text: error.message,
                    icon: 'error'
                })
            }
        })
    }

    const convertComponent = [
        {
            key: "id",
            renderCell: (row: any) => (
                <div style={{ cursor: 'pointer' }} onClick={() => navigate('/purchasing/purchase-request/detail/' + row.value)}>
                    <Typography variant='body2' sx={{ fontWeight: 'bold' }}>
                        {row.value}
                    </Typography>
                </div>
            ),
        },
    ];

    const convertComponentDetailBarang = [
        {
            key: "detail_barang",
            renderCell: (row: any) => (
                <div
                    style={{
                        minWidth: '500px',
                        display: 'block',
                        whiteSpace: 'pre-line',
                        lineHeight: 1.6,
                    }}
                >
                    {String(row.value || '').replace(/\\n/g, '\n')}
                </div>
            ),
        }
    ];

    return (
        <Grid container spacing={3} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            {[1, 2, 4, 6, 12].includes(userData.data.sysrole_id) ??
                listCard.map((item, index) => (
                    <Grid item xs={6} sm={3} key={index}>
                        <CardStats
                            title={item.periode}
                            percentage={item.persen}
                            value1={item.PR}
                            value2={item.PO}
                            value3={item.GR}
                        />
                    </Grid>
                ))
            }
            <Grid item xs={12}>
                <div className={'content-block dx-card'}>
                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                            <CardHeader title='PURCHASE REQUEST' />
                        </Box>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mr: 2 }}>
                            <Fab color='primary' size='medium' onClick={() => navigate('/purchasing/purchase-request/add')}
                            >
                                <Icon icon='mdi:plus' fontSize={35} color='white' />
                            </Fab>
                        </Box>
                    </Box>
                    <Divider />
                    <CardContent>
                        <Grid
                            item
                            container
                            sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start' }}
                            spacing={5}
                        >
                            <Grid item xs={12} md={3}>
                                <FormControl fullWidth>
                                    <InputLabel id='doctag-label'>Jenis Dokumen</InputLabel>
                                    <Select
                                        labelId='doctag-label'
                                        label='Jenis Dokumen'
                                        value={sysdoctagId}
                                        onChange={(e) => setSysdoctagId(e.target.value)}
                                    >
                                        {/* Option Semua */}
                                        <MenuItem value={0}>Semua Data</MenuItem>

                                        {/* List dari API */}
                                        {listDoctag.map((item) => (
                                            <MenuItem key={item.id} value={item.id}>
                                                {item.nama}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <FormControl fullWidth>
                                    <TextField
                                        label='Tanggal Awal'
                                        type='date'
                                        onChange={(e) => setTglAwal(e.target.value)}
                                        value={tglAwal}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <FormControl fullWidth>

                                    <TextField
                                        label='Tanggal Akhir'
                                        type='date'
                                        onChange={(e) => setTglAkhir(e.target.value)}
                                        value={tglAkhir}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <FormControl fullWidth>
                                    <Button
                                        variant='contained'
                                        sx={{ mt: 1 }}
                                        startIcon={<Icon icon='mdi:magnify' />}
                                        onClick={() => getData(tabs)}
                                    >
                                        Cari Data
                                    </Button>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </CardContent>
                    <TabContext value={tabs}>
                        <TabList
                            scrollButtons
                            variant='scrollable'
                            onChange={handleChangeTabs}
                            aria-label='forced scroll tabs example'
                        >
                            <Tab value='1' label='List PR' />
                            <Tab value='2' label='PR Belum Aktif' />
                            <Tab value='3' label='Progress Pembelian' />
                        </TabList>
                        <TabPanel value='1'>
                            <MsiDatagrid customRender={convertComponentDetailBarang} array={listData} actions={actionData} hiddenColumns={['sysdoctag_id', 'is_aktif', 'ot1', 'ot2', 'ot3', 'tgl_close']}
                                rowStyleRules={[
                                    { field: 'is_aktif', operator: '==', value: 0, color: '#ff8787ff' },
                                ]}
                            />
                        </TabPanel>
                        <TabPanel value='2'>
                            {selectedList.length > 0 ? (
                                <Box
                                    sx={{
                                        gap: 2,
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        alignItems: 'center',
                                        justifyContent: 'flex-start',
                                        p: theme => theme.spacing(2, 0, 0, 0)
                                    }}
                                >
                                    <Button
                                        variant='outlined'
                                        onClick={onOtorisasiPR}
                                        startIcon={<Icon icon='mdi:text-box-check-outline' />}
                                    >
                                        Otorisasi Semua ({selectedList.length}) Dokumen PR
                                    </Button>
                                </Box>
                            ) : null}
                            {userData.data.sysrole_id === 2 || userData.data.sysrole_id === 1 ? (
                                <MsiDatagridCheckbox customRender={convertComponentDetailBarang} array={listData} actions={actionData} handleSelection={handleSelection} hiddenColumns={['sysdoctag_id', 'is_aktif', 'ot1', 'ot2', 'ot3', 'tgl_close']} />
                            ) : (
                                <MsiDatagrid customRender={convertComponentDetailBarang} array={listData} actions={actionData} hiddenColumns={['sysdoctag_id', 'is_aktif', 'ot1', 'ot2', 'ot3', 'tgl_close']} />
                            )}
                        </TabPanel>
                        <TabPanel value='3'>
                            <MsiDatagrid array={listData} actions={actionData} customRender={convertComponent} />
                        </TabPanel>
                    </TabContext>
                </div>
            </Grid>
        </Grid>
    )
}